import { DEFAULT_TERM } from "../store/string";

export const MODEL_VOUCHER = {
  active: true,
  branch: "",
  expiry: {
    amount: 10,
    step: "years",
  },
  name: "",
  shopId: "",
  term: DEFAULT_TERM,
};
